import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("chica_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/admin/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("chica_admin_token");
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem("chica_admin_token", data.access_token);
    setAdmin({ email: data.email, role: "admin" });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("chica_admin_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
